import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
var noop = function noop() {};
var enc = encodeURIComponent;
var cbPrefix = '___jsonp';
var count = 0;
var Jsonp = /*#__PURE__*/function () {
  function Jsonp(url) {
    var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      prefix: cbPrefix,
      timeout: 6000,
      id: cbPrefix + ++count
    };
    _classCallCheck(this, Jsonp);
    this.url = url;
    this.opts = opts;
    this.prefix = opts.prefix;
    this.timeout = opts.timeout;
    this.id = opts.id;
    this.script = null;
    this.timer = null;
    this.timeout && this.handelTimeOut();
    return this.fetch();
  }
  _createClass(Jsonp, [{
    key: "fetch",
    value: function fetch() {
      var _this = this;
      var url = this.url,
        opts = this.opts,
        prefix = this.prefix,
        timeout = this.timeout,
        timer = this.timer,
        id = this.id;
      var param = opts.param || 'callback';
      var target = document.getElementsByTagName('script')[0] || document.head;
      url += "".concat((~url.indexOf('?') ? '&' : '?') + param, "=").concat(enc(id));
      url = url.replace('?&', '?');
      this.script = document.createElement('script');
      this.script.src = url;
      target.parentNode.insertBefore(this.script, target);
      return new Promise(function (resolve, reject) {
        window[id] = function (data) {
          _this.cleanup();
          resolve(data);
        };
      });
    }
  }, {
    key: "handelTimeOut",
    value: function handelTimeOut() {
      this.timer = setTimeout(this.cleanup, this.timeout);
    }
  }, {
    key: "cleanup",
    value: function cleanup() {
      var script = this.script,
        timer = this.timer,
        id = this.id;
      if (script.parentNode) script.parentNode.removeChild(script);
      window[id] = null;
      timer && clearTimeout(this.timer);
    }
  }, {
    key: "cancel",
    value: function cancel() {
      window[this.id] && this.cleanup();
    }
  }]);
  return Jsonp;
}();
export default Jsonp;